import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import { pickImplementation } from 'Helpers/Affordances';
import fr from 'facet-rest';
import DialogContentWithMeetingAgenda from 'Components/Modals/EmailTypePicker/DialogContentWithMeetingAgenda';
import useUserContext from 'Context/UserContext';


const styles = () => ({
  paper: {
    width: '100%',
  },
});

const EmailTypePickerDialog = ({
  classes,
  isOpen,
  closeModal,
  ...rest
}) => {
  const isMobile = useMobileLayout();
  const { agentResource } = useUserContext();

  const Content = pickImplementation(agentResource, {
    [fr.relationships.default.name]: DialogContentWithMeetingAgenda,
  });

  return (
    <Dialog
      classes={classes}
      fullScreen={isMobile}
      onClose={closeModal}
      open={isOpen}
      maxWidth="xs"
    >
      <Content
        closeModal={closeModal}
        {...rest}
      />
    </Dialog>
  );
};

EmailTypePickerDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default withStyles(styles)(EmailTypePickerDialog);
